/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { UploadFileStatus as c } from "../interfaces/UploadFileStatus.mjs";
const d = (s) => (s || []).map((t) => ({
  ...t
})), u = (s, t) => {
  t.push(s);
}, l = (s, t) => {
  s.forEach((o) => u(o, t));
}, p = (s) => {
  const t = {};
  return s.forEach((o) => {
    t[o.uid] ? t[o.uid].push(o) : t[o.uid] = [o];
  }), t;
}, i = (s) => {
  let t = {};
  return r(s, (o, a) => {
    let n = !0;
    o.forEach((e) => {
      (e.status !== c.Selected || e.validationErrors && e.validationErrors.length > 0) && (n = !1);
    }), n && (t[a] = o);
  }), t;
}, h = (s, t) => {
  r(s, (o) => {
    o.forEach((a) => {
      a.status = t;
    });
  });
}, f = (s) => {
  let t = [];
  return r(s, (o) => {
    t.push.apply(t, o);
  }), t;
}, r = (s, t) => {
  Object.keys(s).forEach((o) => {
    t(s[o], o);
  });
}, F = {
  copyState: d,
  addMany: l,
  add: u,
  groupFilesByUid: p,
  filesForUpload: i,
  setFilesStatus: h,
  flatFileGroup: f,
  groupForEach: r
};
export {
  F as default
};
